import { APICore } from "./apiCore";

const api = new APICore();

const getRelatorioProntuarioPaciente = (queryString?: string) => {
  return api.get(`/relatorio-prontuario-paciente${queryString ? queryString : ""}`, {
    responseType: "blob",
  });
};

export { getRelatorioProntuarioPaciente };

